/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose a caption style and apply it to selected events" |
*
* @param {Caption_Style_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_description = /** @type {((inputs?: Caption_Style_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un style de sous-titrage et appliquez-le aux événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Bildunterschriftenstil und wenden Sie ihn auf ausgewählte Ereignisse an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli uno stile di didascalia e applicalo agli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите стиль подписи и примените его к выбранным событиям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija un estilo de subtítulo y aplíquelo a los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一种标题样式并将其应用于选定的活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションのスタイルを選択し、選択したイベントに適用します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन शैली चुनें और उसे चयनित इवेंट्स पर लागू करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha um estilo de legenda e aplique-o aos eventos selecionados.")
	return /** @type {LocalizedString} */ ("Choose a caption style and apply it to selected events")
});